import { useMutation, useQuery } from 'react-query';
import queryGetMerchantAccounts from './queries/getMerchantAccounts';
import queryGetX25Centers from './queries/getX25Centers';
import mutationActivateMerchantAccount from './mutations/activateMerchantAccount';
import mutationDeactivateMerchantAccount from './mutations/deactivateMerchantAccount';
import mutationUpdateLabel from './mutations/updateLabel';
import mutationCreateMerchantAccount from './mutations/createMerchantAccount';

const actionsMerchantAccounts = {
    // Getters
    getMerchantAccounts: (params, enabled) => useQuery(queryGetMerchantAccounts(params, enabled)),
    getX25Centers: (params, enabled) => useQuery(queryGetX25Centers(params, enabled)),

    // MerchantAccount creation
    createMerchantAccount: (onSuccess, onError) => useMutation(mutationCreateMerchantAccount(onSuccess, onError)),

    // MerchantAccount status
    activateMerchantAccount: (onSuccess, onError) => useMutation(mutationActivateMerchantAccount(onSuccess, onError)),
    deactivateMerchantAccount: (onSuccess, onError) => useMutation(mutationDeactivateMerchantAccount(onSuccess, onError)),

    // MerchantAccount update label
    updateLabel: (onSuccess, onError) => useMutation(mutationUpdateLabel(onSuccess, onError))
};

export default actionsMerchantAccounts;